import { useState } from "react";
import { faqList } from "@/mocks/homeData";

export default function FaqSection() {
  const [open, setOpen] = useState(0);
  return (
    <section id="faq" className="bg-background-50 py-14 md:py-20">
      <div className="mx-auto grid max-w-7xl gap-10 px-4 md:px-6 lg:grid-cols-[0.8fr_1.2fr] lg:gap-14">
        <div>
          <span className="inline-flex items-center gap-1.5 rounded-full bg-secondary-100 px-3 py-1 text-xs font-bold text-secondary-900">
            <i className="ri-questionnaire-line" aria-hidden="true"></i>吃瓜锦囊
          </span>
          <h2 className="mt-3 text-2xl font-black tracking-tight text-foreground-950 md:text-3xl">
            围观前，先懂规则
          </h2>
          <p className="mt-4 text-sm leading-relaxed text-foreground-700">
            关于栏目更新、投稿爆料与热度算法，最常见的几个疑问都整理在这里。吃瓜有度、
            求证为先，是我们一直坚持的围观姿势。
          </p>
          <a
            href="#about"
            className="mt-6 inline-flex items-center gap-2 whitespace-nowrap rounded-md border border-background-300 bg-background-100 px-5 py-2.5 text-sm font-semibold text-foreground-800 transition-colors hover:border-primary-300 hover:text-primary-700"
          >
            还有疑问？联系我们
            <i className="ri-arrow-right-line" aria-hidden="true"></i>
          </a>
        </div>

        <div className="flex flex-col gap-3">
          {faqList.map((f, i) => {
            const isOpen = open === i;
            return (
              <div
                key={f.q}
                className={`overflow-hidden rounded-xl border transition-colors ${
                  isOpen ? "border-primary-200 bg-background-100" : "border-background-200 bg-background-100"
                }`}
              >
                <button
                  type="button"
                  onClick={() => setOpen(isOpen ? -1 : i)}
                  className="flex w-full items-center justify-between gap-3 px-5 py-4 text-left"
                >
                  <span className="flex items-center gap-3">
                    <span
                      className={`flex h-7 w-7 shrink-0 items-center justify-center rounded-md text-sm font-bold ${
                        isOpen ? "bg-primary-500 text-background-50" : "bg-secondary-100 text-secondary-800"
                      }`}
                    >
                      {String(i + 1).padStart(2, "0")}
                    </span>
                    <span className={`text-sm font-semibold md:text-base ${isOpen ? "text-primary-700" : "text-foreground-900"}`}>
                      {f.q}
                    </span>
                  </span>
                  <i
                    className={`ri-add-line text-xl text-foreground-500 transition-transform duration-300 ${
                      isOpen ? "rotate-45 text-primary-600" : ""
                    }`}
                    aria-hidden="true"
                  ></i>
                </button>
                <div
                  className="grid transition-all duration-300"
                  style={{ gridTemplateRows: isOpen ? "1fr" : "0fr" }}
                >
                  <div className="overflow-hidden">
                    <p className="prose-cg px-5 pb-5 pl-[72px] text-sm leading-relaxed text-foreground-700">
                      {f.a}
                    </p>
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}